export default __webpack_public_path__ + "static/media/PHONEPE3.06e39ba3.png";